/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-return-assign */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/sort-comp */
/* eslint-disable react/no-unused-state */
import React from 'react';
import Grow from '@material-ui/core/Grow';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import { withStyles } from '@material-ui/core/styles';
import { debounce } from 'lodash';

const defaultSearchStyles = theme => ({
  main: {
    display: 'flex',
    flex: '1 0 auto',
  },
  searchIcon: {
    color: theme.palette.text.secondary,
    marginTop: '10px',
    marginRight: '8px',
  },
  searchText: {
    flex: '0.8 0',
  },
  clearIcon: {
    '&:hover': {
      color: theme.palette.error.main,
    },
  },
});

class DebounceTableSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.searchText,
    };
    this.dispatchOnSearch = debounce(this.dispatchOnSearch.bind(this), 1000);
  }

  handleTextChange = event => {
    const { value } = event.target;
    this.setState({
      text: value,
    });
  };

  dispatchOnSearch = value => {
    this.props.onSearch(value);
  };

  componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown, false);
  }

  onKeyDown = event => {
    if (event.keyCode === 13 && this.state.text) {
      this.dispatchOnSearch(this.state.text);
    }
  };

  render() {
    const { classes, options, onHide, searchText } = this.props;
    let value = this.state.text;
    if (searchText && searchText.value !== undefined) {
      value = searchText.value;
    }
    return (
      <Grow appear in timeout={300}>
        <div className={classes.main} ref={el => (this.rootRef = el)}>
          <SearchIcon className={classes.searchIcon} />
          <TextField
            className={classes.searchText}
            autoFocus
            InputProps={{
              'data-test-id': options.textLabels.toolbar.search,
            }}
            inputProps={{
              'aria-label': options.textLabels.toolbar.search,
            }}
            value={value || ''}
            onChange={this.handleTextChange}
            fullWidth
            inputRef={el => (this.searchField = el)}
            placeholder={options.searchPlaceholder}
          />
          <IconButton className={classes.clearIcon} onClick={onHide}>
            <ClearIcon />
          </IconButton>
        </div>
      </Grow>
    );
  }
}

export default withStyles(defaultSearchStyles, { name: 'MUIDataTableSearch' })(
  DebounceTableSearch
);
